import {LENDING_PROGRAM_ID} from "../utils/ids"
import {
  Account,
  PublicKey,
  TransactionInstruction,
} from '@solana/web3.js';
import {
    borrowObligationLiquidityInstruction, Detail,
    Obligation,
    Reserve, TokenAccount,
} from '../models';

import {getConnection, sendTransaction} from "../context/connection";
import {WalletAdapter} from "@/api/wallets";
import {findOrCreateAccountByMint} from "@/api/actions/utils/account";
import {refreshObligation} from "@/api/actions/utils/refreshObligation";
import {refreshReserve} from "@/api/actions/utils/refreshReserve";
import {getObligation} from "@/api/provider/obligationProvider";

// @FIXME
export const borrow = async (
    obligation: Detail<Obligation>,
    borrowReserve: Detail<Reserve>,
    liquidityAmount: number,
    wallet: WalletAdapter,
    allReserve:Array<Detail<Reserve>>,
    lendingProgramId:PublicKey,
    destinationLiquidity?:TokenAccount
) => {
    if (wallet.publicKey == null){
        throw new Error("wallet need connection")
    }
    if (obligation===undefined){
        const myObligations = await getObligation(wallet.publicKey,'userAction')
        if (myObligations.length>0){
            obligation = myObligations[0]
        }
    }
    const connection = await getConnection()
  const signers: Account[] = [];
  const instructions: TransactionInstruction[] = [];
    const cleanupInstructions: TransactionInstruction[] = [];

  const [lendingMarketAuthority] = await PublicKey.findProgramAddress(
    [borrowReserve.info.lendingMarket.toBuffer()],
      lendingProgramId ,
  );

    const destinationLiquidityPubkey = await findOrCreateAccountByMint(
        wallet.publicKey,
        wallet.publicKey,
        instructions,
        cleanupInstructions,
        borrowReserve.info.liquidity.mintPubkey,
        signers,
        destinationLiquidity
    )
    refreshReserve(
        connection,
        signers,
        instructions,
        cleanupInstructions,
        borrowReserve,
        lendingProgramId
    )
    refreshObligation(
        connection,
        signers,
        instructions,
        cleanupInstructions,
        obligation,
        allReserve,
        lendingProgramId
    )
    instructions.push(
        borrowObligationLiquidityInstruction(
            liquidityAmount,
            borrowReserve.info.liquidity.supplyPubkey,
            destinationLiquidityPubkey,
            borrowReserve.pubkey,
            borrowReserve.info.liquidity.feeReceiver,
            obligation.pubkey,
            borrowReserve.info.lendingMarket,
            lendingMarketAuthority,
            obligation.info.owner,
        ),
    );
    return await sendTransaction(
      connection,
      wallet,
      instructions.concat(cleanupInstructions),
      signers,
      true,
  );
};
